import ToastUtil from '../components/ToastNotification/ToastUtil';
import { config } from '../config/index';
const { API_URL } = config;

export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';

export const newFetch = async (
  method,
  path,
  body = null,
  type = 'json',
  returnType = 'json',
  outside_use_flag = false
) => {
  const token = localStorage.getItem('token');

  let url = !outside_use_flag ? `${API_URL + path}` : path;

  let headers = {
    'Access-Control-Allow-Origin': '*',
  };

  if (type === 'json') {
    headers = {
      ...headers,
      'Content-Type': 'application/json; charset=utf-8',
    };
  }

  let config = { method, mode: 'cors', headers };

  if (token) {
    config = {
      ...config,
      withCredentials: true,
      headers: {
        ...headers,
        Authorization: token,
      },
    };

    if (body) {
      config = {
        ...config,
        body: type === 'json' ? JSON.stringify(body) : body,
      };
    }
  } else {
    if (body) {
      config = {
        ...config,
        body: type === 'json' ? JSON.stringify(body) : body,
      };
    }
  }

  try {
    let response = await fetch(url, config);
    let responseData =
      returnType === 'json' ? await response.json() : await response.blob();
    if (response.status === 401 || response.status === 403) {
      const message =
        response.message !== undefined && response.message != ''
          ? response.message
          : 'Invalid sessions. Please login to continue';
      ToastUtil.error(message);
      localStorage.clear();
      window.location.href = window.location.origin;
    } else {
      return responseData;
    }
  } catch (error) {
    console.log(error);
  }
};
